module.exports = "pegasus/assets/themelp1/small/logo.png";